import Container from '../../../elements/Container'
import Section from '../../../elements/Section'
import styles from './styles.module.scss'
import LazyImage from '../../../elements/LazyImage'
import { withModifiers } from '../../../helpers/withModifiers'
import SocialConnect from '../../../custom/SocialConnect'

const SocialPromo = ({ title }) => (
  <Section separator variant={['gray', 'separator-top']}>
    <Container variant={['-xl2', '-p0']}>
      <div className={styles.grid}>
        {Array.from({ length: 9 }).map((item, index) => (
          <div
            key={`grid-item-${index}`}
            className={withModifiers('item', [index + 1], styles)}
          >
            {index !== 4 ? (
              <LazyImage
                objectFit="cover"
                objectPosition="center"
                layout="fill"
                src={`/images/image-blog-gal-${index + 1}.jpg`}
              />
            ) : (
              <>
                {title && <h2>{title}</h2>}

                <SocialConnect variant={['primary', 'large']} />
              </>
            )}
          </div>
        ))}
      </div>
    </Container>
  </Section>
)

export default SocialPromo
